var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTmlogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mango",
    transform: "translate(-163.07 -346.07)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_169",
    "data-name": "Ellipse 169",
    cx: 24,
    cy: 24,
    r: 24,
    transform: "translate(163.07 346.07)",
    fill: "#f2962c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "TagMango_Icon",
    "data-name": "TagMango Icon",
    d: "M38.321,26.339a12.219,12.219,0,0,1,1.272-.431,4.094,4.094,0,0,1,2.582.326A9.658,9.658,0,0,1,45,28.215a.542.542,0,0,1,.063.78,8.505,8.505,0,0,1-3.513,2.463,3.789,3.789,0,0,1-2.509-.01.677.677,0,0,0-.093-.019c.2.378.421.733.6,1.106a6.741,6.741,0,0,1-.231,6.458,15.382,15.382,0,0,1-7.3,6.833,11.5,11.5,0,0,1-5.5.955,7.448,7.448,0,0,1-2.553-.521,3.239,3.239,0,0,1-2.032-3.286,4.155,4.155,0,0,1,1.216-2.714,3.588,3.588,0,0,0,.926-1.893c.219-1.133.39-2.278.65-3.4a8.785,8.785,0,0,1,4.4-5.864,7.206,7.206,0,0,1,6.361-.4c.175.066.248,0,.343-.11a6.83,6.83,0,0,0,1.445-2.816c.144-.534.227-1.084.326-1.63a.6.6,0,0,1,.629-.531.54.54,0,0,1,.5.636c-.093.614-.227,1.223-.346,1.834C38.37,26.181,38.338,26.271,38.321,26.339Z",
    transform: "translate(154.075 335.396)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTmlogo);
export default __webpack_public_path__ + "static/media/tmlogo.6b288b0e07d3ea87975a72482cb6fbf3.svg";
export { ForwardRef as ReactComponent };